import { lazy } from 'react';

// Lazy load all page and component dependencies
const AddHunt = lazy(() => import('../pages/huntingBoard/AddHunt'));
const MobileSearch = lazy(() => import('../components/main/MobileSearch'));
const SlideTransition = lazy(() => import('../components/animation/transition/SlideTransition'));
const Unpublished = lazy(() => import('../pages/Unpublished'));
const PostRegistrationPage = lazy(() => import('../pages/PostRegistrationPage'));
// const Protected = lazy(() => import('./Protected'));
const AddProperty = lazy(() => import('../pages/AddProperty'));

export const withoutLayoutRoutes = [
  {
    path: '/create-property/:type?',
    element: (
      // <Protected>
      <AddProperty />
      // </Protected>
    ),
  },
  {
    path: '/hunting-board/create-hunt/:type/:purpose?',
    element: (
      <SlideTransition>
        <AddHunt />
      </SlideTransition>
    ),
  },
  {
    path: '/search/',
    element: <MobileSearch />,
  },
  {
    path: '/getting-started',
    element: <PostRegistrationPage />,
  },
  {
    path: '/unpublished',
    element: <Unpublished />,
  },
];
